<template>
  <v-app>
    <slot></slot>
  </v-app>
</template>

<script>
export default {}
</script>

<style scoped></style>
